/*! @azure/msal-common v5.1.0 2021-11-02 */
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "AccessTokenEntity", {
  enumerable: true,
  get: function get() {
    return _AccessTokenEntity.AccessTokenEntity;
  }
});
Object.defineProperty(exports, "AccountEntity", {
  enumerable: true,
  get: function get() {
    return _AccountEntity.AccountEntity;
  }
});
Object.defineProperty(exports, "AppMetadataEntity", {
  enumerable: true,
  get: function get() {
    return _AppMetadataEntity.AppMetadataEntity;
  }
});
Object.defineProperty(exports, "AuthError", {
  enumerable: true,
  get: function get() {
    return _AuthError.AuthError;
  }
});
Object.defineProperty(exports, "AuthErrorMessage", {
  enumerable: true,
  get: function get() {
    return _AuthError.AuthErrorMessage;
  }
});
Object.defineProperty(exports, "AuthToken", {
  enumerable: true,
  get: function get() {
    return _AuthToken.AuthToken;
  }
});
Object.defineProperty(exports, "AuthenticationHeaderParser", {
  enumerable: true,
  get: function get() {
    return _AuthenticationHeaderParser.AuthenticationHeaderParser;
  }
});
Object.defineProperty(exports, "AuthenticationScheme", {
  enumerable: true,
  get: function get() {
    return _Constants.AuthenticationScheme;
  }
});
Object.defineProperty(exports, "Authority", {
  enumerable: true,
  get: function get() {
    return _Authority.Authority;
  }
});
Object.defineProperty(exports, "AuthorityFactory", {
  enumerable: true,
  get: function get() {
    return _AuthorityFactory.AuthorityFactory;
  }
});
Object.defineProperty(exports, "AuthorityMetadataEntity", {
  enumerable: true,
  get: function get() {
    return _AuthorityMetadataEntity.AuthorityMetadataEntity;
  }
});
Object.defineProperty(exports, "AuthorityType", {
  enumerable: true,
  get: function get() {
    return _AuthorityType.AuthorityType;
  }
});
Object.defineProperty(exports, "AuthorizationCodeClient", {
  enumerable: true,
  get: function get() {
    return _AuthorizationCodeClient.AuthorizationCodeClient;
  }
});
Object.defineProperty(exports, "CacheAccountType", {
  enumerable: true,
  get: function get() {
    return _Constants.CacheAccountType;
  }
});
Object.defineProperty(exports, "CacheManager", {
  enumerable: true,
  get: function get() {
    return _CacheManager.CacheManager;
  }
});
Object.defineProperty(exports, "CacheSchemaType", {
  enumerable: true,
  get: function get() {
    return _Constants.CacheSchemaType;
  }
});
Object.defineProperty(exports, "CacheType", {
  enumerable: true,
  get: function get() {
    return _Constants.CacheType;
  }
});
Object.defineProperty(exports, "CcsCredentialType", {
  enumerable: true,
  get: function get() {
    return _CcsCredential.CcsCredentialType;
  }
});
Object.defineProperty(exports, "ClientAuthError", {
  enumerable: true,
  get: function get() {
    return _ClientAuthError.ClientAuthError;
  }
});
Object.defineProperty(exports, "ClientAuthErrorMessage", {
  enumerable: true,
  get: function get() {
    return _ClientAuthError.ClientAuthErrorMessage;
  }
});
Object.defineProperty(exports, "ClientConfigurationError", {
  enumerable: true,
  get: function get() {
    return _ClientConfigurationError.ClientConfigurationError;
  }
});
Object.defineProperty(exports, "ClientConfigurationErrorMessage", {
  enumerable: true,
  get: function get() {
    return _ClientConfigurationError.ClientConfigurationErrorMessage;
  }
});
Object.defineProperty(exports, "ClientCredentialClient", {
  enumerable: true,
  get: function get() {
    return _ClientCredentialClient.ClientCredentialClient;
  }
});
Object.defineProperty(exports, "Constants", {
  enumerable: true,
  get: function get() {
    return _Constants.Constants;
  }
});
Object.defineProperty(exports, "CredentialEntity", {
  enumerable: true,
  get: function get() {
    return _CredentialEntity.CredentialEntity;
  }
});
Object.defineProperty(exports, "CredentialType", {
  enumerable: true,
  get: function get() {
    return _Constants.CredentialType;
  }
});
Object.defineProperty(exports, "DEFAULT_CRYPTO_IMPLEMENTATION", {
  enumerable: true,
  get: function get() {
    return _ICrypto.DEFAULT_CRYPTO_IMPLEMENTATION;
  }
});
Object.defineProperty(exports, "DEFAULT_SYSTEM_OPTIONS", {
  enumerable: true,
  get: function get() {
    return _ClientConfiguration.DEFAULT_SYSTEM_OPTIONS;
  }
});
Object.defineProperty(exports, "DefaultStorageClass", {
  enumerable: true,
  get: function get() {
    return _CacheManager.DefaultStorageClass;
  }
});
Object.defineProperty(exports, "DeviceCodeClient", {
  enumerable: true,
  get: function get() {
    return _DeviceCodeClient.DeviceCodeClient;
  }
});
Object.defineProperty(exports, "IdToken", {
  enumerable: true,
  get: function get() {
    return _AuthToken.AuthToken;
  }
});
Object.defineProperty(exports, "IdTokenEntity", {
  enumerable: true,
  get: function get() {
    return _IdTokenEntity.IdTokenEntity;
  }
});
Object.defineProperty(exports, "InteractionRequiredAuthError", {
  enumerable: true,
  get: function get() {
    return _InteractionRequiredAuthError.InteractionRequiredAuthError;
  }
});
Object.defineProperty(exports, "InteractionRequiredAuthErrorMessage", {
  enumerable: true,
  get: function get() {
    return _InteractionRequiredAuthError.InteractionRequiredAuthErrorMessage;
  }
});
Object.defineProperty(exports, "LogLevel", {
  enumerable: true,
  get: function get() {
    return _Logger.LogLevel;
  }
});
Object.defineProperty(exports, "Logger", {
  enumerable: true,
  get: function get() {
    return _Logger.Logger;
  }
});
Object.defineProperty(exports, "NetworkManager", {
  enumerable: true,
  get: function get() {
    return _NetworkManager.NetworkManager;
  }
});
Object.defineProperty(exports, "OIDC_DEFAULT_SCOPES", {
  enumerable: true,
  get: function get() {
    return _Constants.OIDC_DEFAULT_SCOPES;
  }
});
Object.defineProperty(exports, "OnBehalfOfClient", {
  enumerable: true,
  get: function get() {
    return _OnBehalfOfClient.OnBehalfOfClient;
  }
});
Object.defineProperty(exports, "PersistentCacheKeys", {
  enumerable: true,
  get: function get() {
    return _Constants.PersistentCacheKeys;
  }
});
Object.defineProperty(exports, "PopTokenGenerator", {
  enumerable: true,
  get: function get() {
    return _PopTokenGenerator.PopTokenGenerator;
  }
});
Object.defineProperty(exports, "PromptValue", {
  enumerable: true,
  get: function get() {
    return _Constants.PromptValue;
  }
});
Object.defineProperty(exports, "ProtocolMode", {
  enumerable: true,
  get: function get() {
    return _ProtocolMode.ProtocolMode;
  }
});
Object.defineProperty(exports, "ProtocolUtils", {
  enumerable: true,
  get: function get() {
    return _ProtocolUtils.ProtocolUtils;
  }
});
Object.defineProperty(exports, "RefreshTokenClient", {
  enumerable: true,
  get: function get() {
    return _RefreshTokenClient.RefreshTokenClient;
  }
});
Object.defineProperty(exports, "RefreshTokenEntity", {
  enumerable: true,
  get: function get() {
    return _RefreshTokenEntity.RefreshTokenEntity;
  }
});
Object.defineProperty(exports, "ResponseMode", {
  enumerable: true,
  get: function get() {
    return _Constants.ResponseMode;
  }
});
Object.defineProperty(exports, "ScopeSet", {
  enumerable: true,
  get: function get() {
    return _ScopeSet.ScopeSet;
  }
});
Object.defineProperty(exports, "ServerError", {
  enumerable: true,
  get: function get() {
    return _ServerError.ServerError;
  }
});
Object.defineProperty(exports, "ServerTelemetryEntity", {
  enumerable: true,
  get: function get() {
    return _ServerTelemetryEntity.ServerTelemetryEntity;
  }
});
Object.defineProperty(exports, "ServerTelemetryManager", {
  enumerable: true,
  get: function get() {
    return _ServerTelemetryManager.ServerTelemetryManager;
  }
});
Object.defineProperty(exports, "SilentFlowClient", {
  enumerable: true,
  get: function get() {
    return _SilentFlowClient.SilentFlowClient;
  }
});
Object.defineProperty(exports, "StringUtils", {
  enumerable: true,
  get: function get() {
    return _StringUtils.StringUtils;
  }
});
Object.defineProperty(exports, "StubbedNetworkModule", {
  enumerable: true,
  get: function get() {
    return _INetworkModule.StubbedNetworkModule;
  }
});
Object.defineProperty(exports, "ThrottlingEntity", {
  enumerable: true,
  get: function get() {
    return _ThrottlingEntity.ThrottlingEntity;
  }
});
Object.defineProperty(exports, "ThrottlingUtils", {
  enumerable: true,
  get: function get() {
    return _ThrottlingUtils.ThrottlingUtils;
  }
});
Object.defineProperty(exports, "TimeUtils", {
  enumerable: true,
  get: function get() {
    return _TimeUtils.TimeUtils;
  }
});
Object.defineProperty(exports, "TokenCacheContext", {
  enumerable: true,
  get: function get() {
    return _TokenCacheContext.TokenCacheContext;
  }
});
Object.defineProperty(exports, "UrlString", {
  enumerable: true,
  get: function get() {
    return _UrlString.UrlString;
  }
});
Object.defineProperty(exports, "UsernamePasswordClient", {
  enumerable: true,
  get: function get() {
    return _UsernamePasswordClient.UsernamePasswordClient;
  }
});
Object.defineProperty(exports, "version", {
  enumerable: true,
  get: function get() {
    return _packageMetadata.version;
  }
});
var _AuthorizationCodeClient = require("./client/AuthorizationCodeClient.js");
var _DeviceCodeClient = require("./client/DeviceCodeClient.js");
var _RefreshTokenClient = require("./client/RefreshTokenClient.js");
var _ClientCredentialClient = require("./client/ClientCredentialClient.js");
var _OnBehalfOfClient = require("./client/OnBehalfOfClient.js");
var _SilentFlowClient = require("./client/SilentFlowClient.js");
var _UsernamePasswordClient = require("./client/UsernamePasswordClient.js");
var _ClientConfiguration = require("./config/ClientConfiguration.js");
var _AuthToken = require("./account/AuthToken.js");
var _CcsCredential = require("./account/CcsCredential.js");
var _Authority = require("./authority/Authority.js");
var _AuthorityFactory = require("./authority/AuthorityFactory.js");
var _AuthorityType = require("./authority/AuthorityType.js");
var _ProtocolMode = require("./authority/ProtocolMode.js");
var _CacheManager = require("./cache/CacheManager.js");
var _CredentialEntity = require("./cache/entities/CredentialEntity.js");
var _AppMetadataEntity = require("./cache/entities/AppMetadataEntity.js");
var _AccountEntity = require("./cache/entities/AccountEntity.js");
var _IdTokenEntity = require("./cache/entities/IdTokenEntity.js");
var _AccessTokenEntity = require("./cache/entities/AccessTokenEntity.js");
var _RefreshTokenEntity = require("./cache/entities/RefreshTokenEntity.js");
var _ServerTelemetryEntity = require("./cache/entities/ServerTelemetryEntity.js");
var _AuthorityMetadataEntity = require("./cache/entities/AuthorityMetadataEntity.js");
var _ThrottlingEntity = require("./cache/entities/ThrottlingEntity.js");
var _TokenCacheContext = require("./cache/persistence/TokenCacheContext.js");
var _INetworkModule = require("./network/INetworkModule.js");
var _NetworkManager = require("./network/NetworkManager.js");
var _ThrottlingUtils = require("./network/ThrottlingUtils.js");
var _UrlString = require("./url/UrlString.js");
var _ICrypto = require("./crypto/ICrypto.js");
var _ScopeSet = require("./request/ScopeSet.js");
var _AuthenticationHeaderParser = require("./request/AuthenticationHeaderParser.js");
var _Logger = require("./logger/Logger.js");
var _InteractionRequiredAuthError = require("./error/InteractionRequiredAuthError.js");
var _AuthError = require("./error/AuthError.js");
var _ServerError = require("./error/ServerError.js");
var _ClientAuthError = require("./error/ClientAuthError.js");
var _ClientConfigurationError = require("./error/ClientConfigurationError.js");
var _Constants = require("./utils/Constants.js");
var _StringUtils = require("./utils/StringUtils.js");
var _ProtocolUtils = require("./utils/ProtocolUtils.js");
var _TimeUtils = require("./utils/TimeUtils.js");
var _ServerTelemetryManager = require("./telemetry/server/ServerTelemetryManager.js");
var _PopTokenGenerator = require("./crypto/PopTokenGenerator.js");
var _packageMetadata = require("./packageMetadata.js");
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOltdLCJzb3VyY2VzQ29udGVudCI6W10sIm1hcHBpbmdzIjoiIiwiaWdub3JlTGlzdCI6W119